import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { compose, setDisplayName, toClass } from 'recompose';
import AboutScene from './About';
import ErrorScene from './ErrorScene';
import HomeScene from './Home';
import { LoggedInUserProps, withLoggedInUser } from './Login/withLoggedInUser';
import NotFound from './NotFound';
import ActivityListScene from './Strava/ActivityListScene';
import ActivityScene from './Strava/ActivityScene';
import DemoScene from './Strava/Demo';
import DemoActivityScene from './Strava/Demo/DemoActivityScene';

/** Router which presents different routes if the user is logged in */
const LoggedInRouter = compose<LoggedInUserProps, {}>(
    toClass,
    withLoggedInUser,
    setDisplayName('LoggedInRouter')
)(({ loggedInUser, loading }: LoggedInUserProps) => {
    if (loading) {
        return null;
    }

    if (loggedInUser) {
        return (
            <Switch>
                <Route
                    exact={true}
                    path={'/activities'}
                    component={ActivityListScene}
                />
                <Route
                    exact={true}
                    path={'/activities/:activityId'}
                    component={ActivityScene}
                />
                <Route component={NotFound} />
            </Switch>
        );
    }

    // Redirect back to the home page if we aren't logged in
    return (
        <Switch>
            <Redirect to="/" />
        </Switch>
    );
});

/** Default application router for routes which do not require Strava authentication */
export default setDisplayName('AppRouter')(() => (
    <Switch>
        <Route exact={true} path={'/'} component={HomeScene} />
        <Route exact={true} path={'/examples'} component={DemoScene} />
        <Route
            exact={true}
            path={'/examples/:activityId'}
            component={DemoActivityScene}
        />
        <Route exact={true} path={'/about'} component={AboutScene} />
        <Route exact={true} path={'/error'} component={ErrorScene} />
        {/* For all other routes, use the logged-in router */}
        <Route path="/" component={LoggedInRouter} />
    </Switch>
));



// WEBPACK FOOTER //
// ./src/client/components/AppRouter.tsx